var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"mb-2",class:{ 'background-dark': _vm.dark },attrs:{"label":_vm.label,"item-text":"label","items":_vm.teamsFormatted,"rules":[_vm.rules.required],"multiple":_vm.isMultiple,"hint":_vm.hint,"persistent-hint":""},model:{value:(_vm.selectedTeam),callback:function ($$v) {_vm.selectedTeam=$$v},expression:"selectedTeam"}})
}
var staticRenderFns = []

export { render, staticRenderFns }